//
//
//
//
//
//
//
import { getSignatureImage } from '@/api/module/index';
export default {
  components: {},
  data: function data() {
    return {
      resultImg: "",
      informedID: ""
    };
  },
  created: function created() {
    this.informedID = this.$route.query.informedID;
    this.SignatureImage();
  },
  methods: {
    SignatureImage: function SignatureImage() {
      var _this = this;

      getSignatureImage({
        "informedID": this.informedID
      }).then(function (res) {
        _this.resultImg = window.g.VUE_APP_URL + "/images" + _this.resultImg + res.data;
      });
    }
  }
};